module.exports = __webpack_public_path__ + "img/10d.b2a2d95d.svg";